module.exports = __webpack_public_path__ + "static/img/h-gov.1fe8541.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/home/h-gov.jpg
// module id = qMvE
// module chunks = 1